import { useAppDispatch, useAppSelector } from '@state/hooks'
import { generateIVP } from '@state/slices/ivpSlice'
import './IVPGroundingBadge.css'

function IVPGroundingBadge() {
  const dispatch = useAppDispatch()
  const ivp = useAppSelector((s) => s.ivp.ivp)
  const activeCompanyId = useAppSelector((s) => s.companies.activeCompanyId)
  const generating = useAppSelector((s) => s.ivp.generating)

  const handleGenerate = () => {
    if (!activeCompanyId) return
    const numericId = Number(String(activeCompanyId).replace(/^company_/, ''))
    dispatch(generateIVP({ companyId: numericId }))
  }

  if (ivp) {
    return (
      <div className="ivp-grounding-badge">
        <strong className="ivp-label">Grounded in:</strong>{' '}
        <span>{ivp.industry_label} IVP · NAICS {ivp.naics_code} · {ivp.revenue_tier} revenue</span>
      </div>
    )
  }

  return (
    <div className="ivp-grounding-badge ivp-missing">
      <span>Industry context not yet generated</span>
      {activeCompanyId && (
        <button
          className="ivp-action-link"
          onClick={handleGenerate}
          disabled={generating}
        >
          {generating ? 'Generating…' : 'Generate IVP'}
        </button>
      )}
    </div>
  )
}

export default IVPGroundingBadge
